module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-05-20-931.7197d2e8.mp4";